import { BrowserRouter as Router } from 'react-router-dom';

import { LocaleContextController } from 'context/locale/localeContextController/LocaleContextController';
import { ApiClientContextController } from '../context/apiClient/apiClientContextController/ApiClientContextController';
import { AuthContextController } from '../context/auth/authContextController/AuthContextController';

import { AppProvidersProps } from './AppProviders.types';

export const AppProviders = ({ children }: AppProvidersProps) => (
  <Router>
    <LocaleContextController>
      <AuthContextController>
        <ApiClientContextController>{children}</ApiClientContextController>
      </AuthContextController>
    </LocaleContextController>
  </Router>
);
